import type * as React from "react";
import { type GoogleMarker } from "../../salesPartnerTypes";
import { containsFeature, SalesPartnerFeature } from "../../salesPartnerTransformers";
import classNames from "classnames";
import { Logos } from "../../../common/components/Logos";
import { Card } from "../../../Configurators/Linear/components/Card";
import { Icon } from "../../../common/components/icon/Icon";
import { IconType } from "../../../common/components/icon/IconType";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  marker: GoogleMarker;
  onClose: () => void;
  openDetailsPopup: () => void;
}

export const MobileMapTile = (props: Props) => {
  const { marker, onClose, openDetailsPopup, className } = props;

  const { t } = useTranslation();

  const hasINA = containsFeature(marker.features, SalesPartnerFeature.INA);
  const hasFAG = containsFeature(marker.features, SalesPartnerFeature.FAG);
  const cls = classNames("scha__sp__list-card", className);

  const closeCb = (e: React.SyntheticEvent<unknown>) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <Card as={"div"} className={cls} onClick={openDetailsPopup} data-test-id={"sales-partner-tile"}>
      <div className={"scha__sp__list-card__data"}>
        <h5 className="scha__sp__list-card__name">{marker.address.companyNameDisplay}</h5>
        <p className="scha__sp__list-card__address">
          {`${marker.address.postalCode} ${marker.address.town}, ${t(marker.address.country.name)}`}
        </p>
        <p className="scha__sp__list-card__distance">{marker.formattedDistance !== "" && marker.formattedDistance}</p>
      </div>

      <div className={"scha__sp__list-card__logos"}>
        <IconButton color={"primary"} onClick={closeCb}>
          <Icon type={IconType.Close} />
        </IconButton>
        {hasINA && <Logos.INA />}
        {hasFAG && <Logos.FAG />}
      </div>
    </Card>
  );
};
